export default (el) => {
  console.log('once animation!');
}
